<template>
  <AVProgressBar
    :id="id"
    :value="progressPercentage"
  />
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { PropType, E2E } from "@/types";

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  resultOrchestrator: {
    required: true,
    type: Object as PropType<E2E.ResultOrchestrator>,
  },
});

const progressPercentage = computed(() => (props.resultOrchestrator.overallProgress ?? 0) * 100);
</script>
